import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import thunk from 'redux-thunk';
import PropTypes from 'prop-types';

import ChecklistNavigator from './components/checklist_navigator';
import reducers from './reducers';

export default class ChecklistEditor extends Component {
  static propTypes = {
    addChecklistItemPath: PropTypes.string,
    checklistItems: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      listingType: PropTypes.string,
      projectStatus: PropTypes.string,
      taskTitle: PropTypes.string
    })),
    limitToUsers: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    const startingState = {
      checklistItems: props.checklistItems,
      checklistItemModal: {
        addChecklistItemPath: props.addChecklistItemPath,
        show: false,
        listingType: 'SaleListing',
        projectStatus: 'proposal',
        item: null
      },
      limitToUsers: props.limitToUsers
    };

    this.store = createStore(reducers, startingState, applyMiddleware(thunk));

    if (module.hot) {
      module.hot.accept('./reducers/index', () => {
        this.store.replaceReducer(require('./reducers/index'));
      });
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <ChecklistNavigator/>
      </Provider>
    );
  }
}
